import { ContentfulBlocks } from '@dreamstack/accentro-contentful/src/contentful/ContentfulBlocks'
import {
  GridWithGaps,
  GridWithGapsNoCols,
} from '@dreamstack/feature-components/src/layout/MainGrid'
import { RatingArrow } from '@dreamstack/icons/src/icon-components/RatingArrow'
import { StaticPageBlock } from '@dreamstack/payload/src/blocks/all/staticPageBlocks'
import { cn } from '@dreamstack/util/src/cn'
import React from 'react'

const StyledRatingArrow = ({ className }: { className?: string }) => (
  <RatingArrow
    className={cn(
      'text-accentroGray-100 h-[342px] w-[342px] lg:h-[368px] lg:w-[368px]',
      'transform -translate-x-px-80 md:translate-x-0 md:absolute md:top-0 md:right-[32px] ml:right-[56px]',
      className
    )}
  />
)

const AnalystRatingWrapper = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => (
  <GridWithGapsNoCols
    className={cn(
      'grid-cols-1 col-span-full pb-px-96 gap-y-px-48 order-1',
      'md:grid-cols-2 md:col-start-5 md:col-end-13 md:gap-y-px-96 md:order-2',
      'ml:grid-cols-3 ml:col-start-2 ml:col-end-13',
      className
    )}
  >
    {children}
  </GridWithGapsNoCols>
)

// type AnalystRatingsProps = {
//   blocks: QueryAllBlocksRecursivelyResult[]
// }

const AnalystRatings = ({ blocks }: { blocks: StaticPageBlock[] }) => {
  return (
    <GridWithGaps>
      <div
        className={cn(
          'order-2 md:order-1 md:col-span-4 ml:col-span-1 relative'
        )}
      >
        <StyledRatingArrow />
      </div>
      <AnalystRatingWrapper>
        <ContentfulBlocks blocks={blocks} />
      </AnalystRatingWrapper>
    </GridWithGaps>
  )
}

export default AnalystRatings
